export const REACT_SERVER_SRC="https://backendcardshop.onrender.com"/*"http://localhost:3001"*/;